/*! @azure/msal-common v16.11.0 2026-06-30 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "16.11.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
